import { Injectable, signal } from '@angular/core';
import { CalculationParameter } from '../data/models/CalculationParameter';

@Injectable({
  providedIn: 'root'
})
export class CalculationParametersService {
  calculationParameters = signal<CalculationParameter | null>(null);

  setCalculationParameters(calculationPatameter: CalculationParameter) {
    this.calculationParameters.set(calculationPatameter);
  }

  getCalculationParameters() {
    return this.calculationParameters();
  }

}
